module.exports = __webpack_public_path__ + "static/media/img-tv-landing.aba3d498.svg";